<template>
    <div class="page-table scrollable only-y mainDiv">
        <div class="page-header card-base card-shadow--small"
             style="height: 0; margin-bottom: 10px; padding: 12px 24px 24px;">
            <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-top: 0">
                <el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
                <el-breadcrumb-item> {{$t("src.views.apps.referans.title")}}</el-breadcrumb-item>
                <el-breadcrumb-item> {{$t("src.views.apps.referans.liste.title")}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="card-base baslikBg animated fadeInUp">Yayındaki Referanslar</div>
        <div class="page-header card-base card-shadow--medium animated fadeInUp">
            <el-table
                    :data="referanslarListYayinda"
                    style="width: 100%">
                <el-table-column
                        label="Sıra"
                        type="index">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="baslik"
                        label="Başlık"
                        width="auto">
                </el-table-column>
                <el-table-column
                        prop="olusturan"
                        label="Oluşturan"
                        width="auto">
                </el-table-column>
                <el-table-column
                        label="İşlem"
                        align="right"
                        width="auto">
                    <template slot-scope="scope">
                        <router-link :to="{ path:'/referans/guncelleme?referansKodu='+scope.row.referansKodu}">
                            <el-tooltip :content='$t("src.views.apps.referans.liste.referansduzenle")'
                                        :open-delay="500"
                                        placement="bottom">
                                <el-button
                                        type="warning"
                                        size="mini"
                                        icon="el-icon-edit">
                                </el-button>
                            </el-tooltip>
                        </router-link>
                        &nbsp;
                        <el-link target="_blank" :underline="false" :href="pathh+scope.row.link">
                            <el-tooltip :content='$t("src.views.apps.referans.liste.referansdetay")' :open-delay="500"
                                        placement="bottom">
                                <el-button
                                        style="margin-bottom: 5px"
                                        type="info"
                                        size="mini"
                                        icon="mdi mdi-redo-variant">
                                </el-button>
                            </el-tooltip>
                        </el-link>
                        &nbsp;
                        <el-tooltip :content='$t("src.views.apps.referans.liste.yayindanKaldir")' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    class="durdurBtn"
                                    @click="deleteDialogVisible = true; selection = scope.row; selectionIndex = scope.$index"
                                    size="mini"
                                    icon="mdi mdi-pause">
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    background
                    layout="sizes,prev, pager, next, jumper, total"
                    :total="total"
                    @size-change="handleSizeChange"
                    @current-change="pageChange"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page.sync="page"
                    :next-click.sync="page"
                    :prev-click.sync="page"
                    @next-click="pageChange"
                    @prev-click="pageChange">
            </el-pagination>
        </div>
        <div class="card-base kaldirilmis animated fadeInUp delay-1s">Taslak Referanslar</div>
        <div class="page-header card-base card-shadow--medium animated fadeInUp delay-2s">
            <el-table
                    :data="referanslarListTaslak"
                    style="width: 100%">
                <el-table-column
                        label="Sıra"
                        type="index">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="baslik"
                        label="Başlık"
                        width="auto">
                </el-table-column>
                <el-table-column
                        prop="olusturan"
                        label="Oluşturan"
                        width="auto">
                </el-table-column>
                <el-table-column
                        label="İşlem"
                        align="right"
                        width="auto">
                    <template slot-scope="scope">
                        <router-link :to="{ path:'/referans/guncelleme?referansKodu='+scope.row.referansKodu}">
                            <el-tooltip :content='$t("src.views.apps.referans.liste.referansduzenle")'
                                        :open-delay="500"
                                        placement="bottom">
                                <el-button
                                        type="warning"
                                        size="mini"
                                        icon="el-icon-edit">
                                </el-button>
                            </el-tooltip>
                        </router-link>
                        &nbsp;
                        <el-link target="_blank" :underline="false" :href="pathh+scope.row.link">
                            <el-tooltip :content='$t("src.views.apps.referans.liste.referansdetay")' :open-delay="500"
                                        placement="bottom">
                                <el-button
                                        style="margin-bottom: 5px"
                                        type="info"
                                        size="mini"
                                        icon="mdi mdi-redo-variant">
                                </el-button>
                            </el-tooltip>
                        </el-link>
                        &nbsp;
                        <el-tooltip :content='$t("src.views.apps.referans.liste.yayinaAl")' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    @click="changeSayfaDurum(scope.row, scope.$index, referanslarListTaslak,'1');"
                                    size="mini"
                                    type="primary"
                                    icon="mdi mdi-play">
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    background
                    layout="sizes,prev, pager, next, jumper, total"
                    :total="totalTaslak"
                    @size-change="handleSizeChangeTaslak"
                    @current-change="pageChangeTaslak"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page.sync="pageTaslak"
                    :next-click.sync="pageTaslak"
                    :prev-click.sync="pageTaslak"
                    @next-click="pageChangeTaslak"
                    @prev-click="pageChangeTaslak">
            </el-pagination>
        </div>
        <el-dialog
                :title='$t("src.views.apps.referans.liste.uyari")'
                :visible.sync="deleteDialogVisible"
                width="30%"
                center>
            <span>'{{selection.baslik}}' {{$t('src.views.apps.referans.liste.referanstaslak')}}</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="changeSayfaDurum(selection,selectionIndex,referanslarListYayinda,'0'), deleteDialogVisible = false"></el-button>
                    <el-button type="danger" size="mini" icon="el-icon-close"
                               @click="deleteDialogVisible = false"></el-button>
                </span>
        </el-dialog>
    </div>

</template>

<script>
    import referansService from '../../../WSProvider/ReferansService'
    import status from '../../../status'

    let base64 = require('base64_js');
    let userDataArtdoor = "";

    export default {
        name: "ReferansListe",
        data() {
            return {
                pathh: "http://artdoor.com.tr/",
                sizes: 10,
                sizesTaslak: 10,
                page: 0,
                pageTaslak: 0,
                postPage: 0,
                postPageTaslak: 0,
                total: null,
                totalTaslak: null,
                referanslarListYayinda: [],
                referanslarListTaslak: [],
                deleteDialogVisible: false,
                taslakDialogVisible: false,
                selection: '',
                selectionIndex: '',
            }
        },
        mounted() {
            let state = false;
            if (localStorage.getItem("userDataArtdoor")) {
                userDataArtdoor = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataArtdoor"))));
                if (userDataArtdoor["tur"]) {
                    if (userDataArtdoor["tur"] === '1' || userDataArtdoor["tur"] === '2')
                        state = true;
                }
            }
            if (!state) {
                this.$store.commit('setLogout');
                this.$router.push("/login");
            } else {
                this.referansCount();
                this.getReferansList('1');
                this.getReferansList('0');
            }
        },
        methods: {
            handleSizeChange(val) {
                this.sizes = val;
                this.getReferansList('1');
            },
            handleSizeChangeTaslak(val) {
                this.sizesTaslak = val;
                this.getReferansList('1');
            },
            pageChange(val) {
                this.postPage = (val - 1) * this.sizes;
                this.getReferansList('1');
            },
            pageChangeTaslak(val) {
                this.postPageTaslak = (val - 1) * this.sizesTaslak;
                this.getReferansList('1');
            },
            referansCount() {
                referansService.referansCount(1).then((response) => {
                    if (response.status === 200) {
                        this.total = parseInt(response.data.count);
                    }
                });
                referansService.referansCount(0).then((response) => {
                    if (response.status === 200) {
                        this.totalTaslak = parseInt(response.data.count);
                    }
                })
            },
            getReferansList(durum) {
                referansService.referansList(this.postPage, this.sizes, durum).then((response) => {
                    if (response.status === 200) {
                        switch (durum) {
                            case '0':
                                this.referanslarListTaslak = response.data;
                                break;
                            case '1':
                                this.referanslarListYayinda = response.data;
                                break;
                        }
                    } else {
                        status.Status(response.status, this)
                    }
                });
            },
            changeSayfaDurum(selection, index, list, durum) {
                referansService.referansDurumChange(selection.referansKodu, durum).then((response) => {
                    if (response.status === 200) {
                        switch (durum) {
                            case '0':
                                this.referanslarListTaslak.push(selection);
                                list.splice(index, 1);
                                break;
                            case '1':
                                this.referanslarListYayinda.push(selection);
                                list.splice(index, 1);
                                break;
                        }
                    } else {
                        status.Status(response.status, this)
                    }
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
    .el-pagination {
        margin-top: 20px;
        float: right;
    }

    .kaldirilmis {
        background: #ec205f;
        color: white;
        font-weight: bold;
        font-size: 16px;
        padding: 10px
    }
</style>